import { ColoursObj, Icon } from "@eventr/common-storybook";
import { rasterizeReactIcon } from "./rasterize";

export const TOOLBAR_ICON_SCALE = 3;

// Rasterised toolbar icons, cached by icon name. Once an icon is cached, a view that
// uses it builds its native bar button synchronously (before the view is revealed),
// so the button appears with the push instead of flashing in afterwards.
const cache = new Map<string, string>();

export function getToolbarIcon(name: string): string | undefined {
  return cache.get(name);
}

export async function ensureToolbarIcon(name: string): Promise<void> {
  if (cache.has(name)) return;
  const uri = await rasterizeReactIcon(
    <Icon name={name as never} iconColour={ColoursObj.shades.shade1} />,
    24,
    TOOLBAR_ICON_SCALE,
  );
  if (uri) cache.set(name, uri);
}

// The icons used in navigation bar toolbars. Pre-warmed at startup so the first view
// that uses one already has it cached. Any icon not listed is still rasterised on
// demand the first time it is used.
const PREWARM_ICONS = [
  "Add",
  "Add_User",
  "Add_Group",
  "Edit",
  "Edit_Text",
  "Free_Edit",
  "Delete",
  "Send",
  "Tick",
  "Cross",
  "Clear",
  "Cancel",
  "Copy",
  "Share",
  "Attach",
  "Filter",
  "Filter2",
  "Search",
  "Settings",
  "Kebab",
  "More",
  "Customise",
  "Qr_Code",
  "Link",
  "Download",
  "ReadAll",
  "User",
  "Users",
  "Chevron_Left",
];

let prewarmStarted = false;

/** Rasterise the common toolbar icons in the background (idempotent). */
export function prewarmToolbarIcons(): void {
  if (prewarmStarted) return;
  prewarmStarted = true;
  void Promise.all(PREWARM_ICONS.map((name) => ensureToolbarIcon(name)));
}
